import { offerActionTypes } from '@Actions/offerActions';

const OfferReducer = (state = { }, action) => {
  switch (action.type) {
  case offerActionTypes.CREATE_OFFER.LOADING: {
    const { createOfferLoading } = action;
    return {
      ...state,
      createOfferLoading,
    };
  }
  case offerActionTypes.CREATE_OFFER.SUCCESS: {
    const { createdOffer } = action;
    return {
      ...state,
      createdOffer,
    };
  }
  case offerActionTypes.GET_OFFER_BY_ID.LOADING: {
    const { getOfferByIdLoading } = action;
    return {
      ...state,
      getOfferByIdLoading,
    };
  }
  case offerActionTypes.GET_OFFER_BY_ID.SUCCESS: {
    const { selectedOffer } = action;
    return {
      ...state,
      selectedOffer,
    };
  }
  case offerActionTypes.GET_OFFERS.LOADING: {
    const { getOffersLoading } = action;
    return {
      ...state,
      getOffersLoading,
    };
  }
  case offerActionTypes.GET_OFFERS.SUCCESS: {
    const { offers } = action;
    return {
      ...state,
      offers,
    };
  }
  case offerActionTypes.GET_OFFER_BY_SKU.LOADING: {
    const { getOffersBySkuLoading } = action;
    return {
      ...state,
      getOffersBySkuLoading,
    };
  }
  case offerActionTypes.GET_OFFER_BY_SKU.SUCCESS: {
    const { sellerOffers } = action;
    return {
      ...state,
      sellerOffers,
    };
  }
  case offerActionTypes.UPDATE_OFFER.LOADING: {
    const { updateOfferLoading } = action;
    return {
      ...state,
      updateOfferLoading,
    };
  }
  case offerActionTypes.DELETE_OFFER.LOADING: {
    const { deleteOfferLoading } = action;
    return {
      ...state,
      deleteOfferLoading,
    };
  }
  case offerActionTypes.GET_SELLING_PRICE.LOADING: {
    const { getSellingPricesLoading } = action;
    return {
      ...state,
      getSellingPricesLoading,
    };
  }
  case offerActionTypes.GET_SELLING_PRICE.SUCCESS: {
    const { prices } = action;
    return {
      ...state,
      prices,
    };
  }
  case offerActionTypes.CREATE_SELLING_PRICE.LOADING: {
    const { createSellingPriceLoading } = action;
    return {
      ...state,
      createSellingPriceLoading,
    };
  }
  case offerActionTypes.UPDATE_SELLING_PRICE.LOADING: {
    const { updateSellingPriceLoading } = action;
    return {
      ...state,
      updateSellingPriceLoading,
    };
  }
  case offerActionTypes.GET_OFFER_BY_TENANT_SKU.LOADING: {
    const { getOfferByTenantSkuLoading } = action;
    return {
      ...state,
      getOfferByTenantSkuLoading,
    };
  }
  case offerActionTypes.GET_OFFER_BY_TENANT_SKU.SUCCESS: {
    const { tenantSkuOffer } = action;
    return {
      ...state,
      tenantSkuOffer,
    };
  }
  case offerActionTypes.GET_ALL_SELLER_OFFERS.LOADING: {
    const { getAllSellerOffersLoading } = action;
    return {
      ...state,
      getAllSellerOffersLoading,
    };
  }
  case offerActionTypes.GET_ALL_SELLER_OFFERS.SUCCESS: {
    const { allSellerOffers } = action;
    return {
      ...state,
      allSellerOffers,
    };
  }

  case offerActionTypes.ARCHIVE_OFFER_PRICE.LOADING: {
    const { archiveOfferPriceLoading } = action;
    return {
      ...state,
      archiveOfferPriceLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default OfferReducer;
